export default {
  SET_SCHEDULE_WEEK(state, schedule) {
    Object.assign(state.currentSchedule[schedule.gameId-1], schedule);
  },
  ADD_SCHEDULE_WEEK(state, schedule) {
    var week = new Object;
    Object.assign(week, schedule);

    state.currentSchedule[week.gameId-1] = week;
  },
  SET_CURRENT_SCHEDULE(state, schedule) {
    console.group("SET_CURRENT_SCHEDULE");

    console.info("schedule");
    console.table(schedule);

    state.currentSchedule = [];

    for (var i = 0; i < schedule.length; i++) {
      const week = new Object;

      Object.assign(week, schedule[i]);
      state.currentSchedule.push(week);
    }

    console.info("currentSchedule");
    console.table(state.currentSchedule);
    console.groupEnd();
  },
  CLEAR_CURRENT_SCHEDULE(state) {
    state.currentSchedule = [];
  },
  CLEAR_ALL_SCHEDULES(state) {
    state.schedulesList = [];
  },
  LOAD_SCHEDULE(state, schedule) {
    console.group("LOAD_SCHEDULE");

    // the below might be overkill
    // const newSchedule = [];
    // for (var i = 0; i < schedule.length; i++) {
    //   const week = new Object;

    //   Object.assign(week, schedule[i]);
    //   newSchedule.push(week);
    // }
    // state.schedulesList.push(newSchedule);
    // console.info("newSchedule = ", newSchedule);

    // try this instead
    state.schedulesList.push(schedule);
    console.info("schedule = ", schedule);

    console.info("schedulesList");
    console.table(state.schedulesList);

    console.groupEnd();
  }
};
